import { style } from "@vanilla-extract/css";

export const slideContainerStyle = style({
  padding: "var(--custom-padding, var(--padding))",
});
